import Border from "./border";
import "./page-sub-title.css";

export type PageSubTitleProps = {
    label: string;
    name: string;
    image?: string;
};

export const PageSubTitle: React.FC<PageSubTitleProps> = ({ label, name, image }) => (
    <div className={`page-sub-header ${name}-header`}>
        <img src={image} alt={`${label} Icon`} />
        <Border>
            <div className={`page-sub-title ${name}-title`}>
                {label}
            </div>
        </Border>
        <img src={image} alt={`${label} Icon`} />
    </div >
);
